import { InsuranceType, MainPath } from "Constants/constants";

export const PRODUCT_PATH = `/${MainPath.CHECK_PRICE}/${InsuranceType.CHILD}`;
export const CHILD_MAX_AGE = 16;
export const CHILD_END_AGE = 26;
